import Vue from "vue";
import store from "@/store/index";
import { Logger } from "aws-amplify";
const logger = new Logger("global-mixin-logger", process.env.VUE_APP_LOGLEVEL);

export default Vue.extend({
  data() {
    return {
      moduleName: null,
      $logger: null,
      $i18n: null,
      ruleFileDisable: false,
      // VALIDACIONES
      required(propertyType: any) {
        return (v: any) => !!v || `Campo ${propertyType} requerido`;
      },
      maxLength(propertyType: any, maxLength: number) {
        return (v: string) =>
          (v && v.length <= maxLength) ||
          `Campo ${propertyType} debe ser de maximo ${maxLength}`;
      },
      requiredFile(propertyFile: any) {
        if (!this.ruleFileDisable) {
          return (v: File) =>
            (v && v.size > 0) || `Campo ${propertyFile} requerido`;
        } else {
          return true;
        }
      },
      numberType(propertyType: any) {
        return (v: string) =>
          /[$%\^]/.test(v) || `Campo ${propertyType} no debe tener letras`;
      },
      specialCharacter(propertyType: any) {
        return (v: string) =>
          /^[\w&.\ /]+$/.test(v) ||
          `Campo ${propertyType} no debe contener caracteres especiales`;
      },
      fileExtentionValid(propertyFile: string) {
        if (!this.ruleFileDisable) {
          return (v: File) =>
            /^.*\.(jpg|JPG|png|PNG|pdf|PDF)$/.test(
              v == undefined ? "" : v.name
            ) || `Campo ${propertyFile} no es de tipo .pdf, .jpg o .png`;
        } else {
          return true;
        }
      },
      getFileExtention(fileName: string) {
        if (fileName) {
          return fileName
            .split(".")
            .pop()
            .toLowerCase();
        } else {
          return "";
        }
      },
    };
  },
  created() {
    if (this.moduleName) {
      this.$logger = new Logger(
        `${this.moduleName}-logger`,
        process.env.VUE_APP_LOGLEVEL
      );
      this.$logger.debug(`::INIT:${this.moduleName}`);
    }
  },

  methods: {
    updateLocale() {
      this.$logger.debug(
        `'Mixin.updateLocale':${this.moduleName}, locale: ${this.locale}`
      );
    },
  },
  computed: {
    // Se realizar el mapeo de las propiedades isLoading y locale del STATE (Vuex)
    locale: function() {
      return store.getters[`i18n/getLocale`];
    },
    // isLoading:  function(){ return store.getters[`isLoading`]},
    build: function() {
      return store.getters[`getBuild`];
    },
    // Determina el permiso de consulta
    consultaPermiso: function() {
      const permissions: { [key: string]: any } = JSON.parse(
        store.getters["auth/permissions"]
      );
      let permiso = false;
      if (
        permissions.length > 3 &&
        permissions[3].hasOwnProperty("Consultar") &&
        permissions[3].Consultar == "1"
      ) {
        permiso = true;
      } else if (["1", "2"].includes(store.getters["auth/rol"])) {
        permiso = true;
      }
      return permiso;
    },
    // Determina el permiso de agregar
    crearPermiso: function() {
      const permissions: { [key: string]: any } = JSON.parse(
        store.getters["auth/permissions"]
      );
      let permiso = false;
      if (
        permissions.length > 0 &&
        permissions[0].hasOwnProperty("Crear") &&
        permissions[0].Crear == "1"
      ) {
        permiso = true;
      }
      return permiso;
    },
    // Determina el permiso de editar
    modificarPermiso: function() {
      const permissions: { [key: string]: any } = JSON.parse(
        store.getters["auth/permissions"]
      );
      let permiso = false;
      if (
        permissions.length > 1 &&
        permissions[1].hasOwnProperty("Modificar") &&
        permissions[1].Modificar == "1"
      ) {
        permiso = true;
      }
      return permiso;
    },
    // Determina el permiso de Autorizar
    autorizarPermiso: function() {
      let permiso = false;
      if (["1", "2", "4"].includes(store.getters["auth/rol"])) {
        permiso = true;
      }
      return permiso;
    },
    // Determina el permiso de eliminar
    eliminarPermiso: function() {
      const permissions: { [key: string]: any } = JSON.parse(
        store.getters["auth/permissions"]
      );
      let permiso = false;
      if (
        permissions.length > 2 &&
        permissions[2].hasOwnProperty("Eliminar") &&
        permissions[2].Eliminar == "1"
      ) {
        permiso = true;
      }
      return permiso;
    },
    // Determina el permiso de rechazar
    rechazarPermiso: function() {
      let permiso = false;
      if (["1", "2", "4"].includes(store.getters["auth/rol"])) {
        permiso = true;
      }
      return permiso;
    },
  },

  watch: {
    locale: {
      immediate: true, // Indica que se debe ejecutar este proceso al iniciar el componente
      handler(value) {
        let { moduleName, $store } = this;

        if (!moduleName) {
          return;
        }
        if (!$store) {
          return;
        }
        if (!value) {
          return;
        }

        $store
          .dispatch("i18n/fetch", {
            module: moduleName,
            i18n: this.$i18n,
          })
          .then(() => {
            this.$logger.debug(
              `'Mixin.watch.locale'.done: ${moduleName}, locale: ${value}`
            );
            this.updateLocale();
          })
          .catch(() => {
            this.$logger.warning(
              `'Mixin.watch.locale'.error: ${moduleName}, locale: ${value}`
            );
            this.updateLocale();
          });
      },
    },
  },
});
